/**
 * 'Index'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import AppRouter from './app/app.router'
import CommonRouter from './common/common.router'

export default [
  ...AppRouter,
  ...CommonRouter
]



// WEBPACK FOOTER //
// ./src/router/routes/index.js